import React, { useContext, useEffect, useState } from 'react';
import './map.scss';
import {
  MapContainer,
  TileLayer,
  ZoomControl,
  useMapEvents,
  Marker,
  Polygon,
  Popup,
} from 'react-leaflet';
import PosicoesContext from '../../context/posicoes.context';
import CidadesContext from '../../context/cidades.context';
import FirebaseContext from '../../context/firebase.context';
import 'leaflet/dist/leaflet.css';
import Loader from '../../assets/loader.gif';
import ClickPopUp from './popups';

export default function Map() {
  const token = 'pk.eyJ1IjoicHJvZ3JhbWFkb3JlbWVyc29uIiwiYSI6ImNra2UwZGh1NDA2Z2syd3A3YnNtZDI4cngifQ.PQKV7NSg34g3-1MsL3qi0Q';
  const urlBase = `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=${token}`;
  const atribuicao = 'copy <a href="http://agsafe.com.br">AGSAFE</a>';
  const {
    positionsViwer, nowMarker: marker, iconeClick, clickPopUp, setShowPopUp,
    temp: { positions: poligon }, setarInformacoesClick, showPopUp, setIsScreenCertifield,
  } = useContext(PosicoesContext);
  const { actualLocation } = useContext(CidadesContext);
  const { ListnnerNotifications } = useContext(FirebaseContext);
  const [reload, setReload] = useState(true);

  useEffect(() => {
    setReload(true);
    setTimeout(() => {
      setReload(false);
    }, 1000);
  }, [actualLocation]);

  useEffect(() => {
    ListnnerNotifications();
    setIsScreenCertifield(false);
  }, []);

  function ClickPosition() {
    const map = useMapEvents({
      click() {
        setShowPopUp(false);
        map.locate();
        map.on('click', (ev) => {
          setarInformacoesClick({
            lat: map.mouseEventToLatLng(ev.originalEvent).lat,
            lng: map.mouseEventToLatLng(ev.originalEvent).lng,
          });
        });
      },
    });
    return null;
  }

  return (
    <section id="content-map-leaflet">
      {!reload ? (
        <MapContainer
          className="mapa"
          center={actualLocation}
          zoomControl={false}
          maxZoom={18}
          zoom={14}
          style={{ height: window.innerHeight - 39 }}
        >
          <TileLayer
            attribution={atribuicao}
            url={urlBase}
            tileSize={512}
            zoomOffset={-1}
            zoomControl={false}
          />
          <ZoomControl
            position="topright"
            zoomOutText="-"
            zoomInText="+"
            zoomOutTitle="- Zoom"
            zoomInTitle="+ Zoom"
          />
          <Marker
            id="bicho"
            class="btn-mensagem"
            position={marker}
            icon={iconeClick}
            eventHandlers={{ click() {} }}
          />

          { (clickPopUp.positions && clickPopUp.positions[0].lat !== 0)
            && (
              showPopUp && (
              <Popup
                onClose={() => setShowPopUp(false)}
                position={
                [
                  clickPopUp.positions[0].lat,
                  clickPopUp.positions[0].lng,
                ]
              }
              >
                <ClickPopUp detalhes={clickPopUp} />
              </Popup>
              )
            )}

          {
            (positionsViwer.length > 0) && positionsViwer
          }

          {
            poligon.length > 2
            && (
              <>
                <Polygon
                  weight={2}
                  color="white"
                  positions={poligon}
                />
              </>
            )
          }

          <ClickPosition />
        </MapContainer>
      ) : (
        <>
          <img src={Loader} alt="Carregando" />
          <span>Carregando Mapa, por favor aguarde...</span>
        </>
      )}
    </section>
  );
}
